export const derivedEventsSectionMessagesEn = {
  // Cohort Builder - Derived Events Content
  'projects.cohortBuilder.derivedEventsSection.title': 'Derived events',
  'projects.cohortBuilder.derivedEventsSection.buttonLabel': 'Derived event',
  'projects.cohortBuilder.derivedEventsSection.eventItemLabel': 'Event',
  'projects.cohortBuilder.derivedEventsSection.typeItemLabel': 'Type',
  'projects.cohortBuilder.derivedEventsSection.noDerivedEventsMainMsg': 'No derived events',
  'projects.cohortBuilder.derivedEventsSection.noDerivedEventsSubMsg':
    'Define a derived event to get started',

  // Cohort Builder - Derived Events Edit Modal
  'projects.cohortBuilderPage.derivedEventsEditModal.editMode.title': 'Edit derived event',
  'projects.cohortBuilderPage.derivedEventsEditModal.createMode.title': 'Create derived event',
  'projects.cohortBuilderPage.derivedEventsEditModal.viewMode.title': 'View derived event',
  'projects.cohortBuilderPage.derivedEventsEditModal.nameLabel': 'Name',
  'projects.cohortBuilderPage.derivedEventsEditModal.namePlaceholder': 'Enter event name',
  'projects.cohortBuilderPage.derivedEventsEditModal.typeLabel': 'Type',
  'projects.cohortBuilderPage.derivedEventsEditModal.typePlaceholder': 'Select event type',
  'projects.cohortBuilderPage.derivedEventsEditModal.titleEvents': 'Events',
  'projects.cohortBuilderPage.derivedEventsEditModal.titleOrder': 'Allow events in any order',
  'projects.cohortBuilderPage.derivedEventsEditModal.uniqueFilterSection.title':
    'Uniqueness filters',
  'projects.cohortBuilderPage.derivedEventsEditModal.temporalConstraintsSection.title':
    'Temporal constraints',

  // Cohort Builder - Derived Events Edit Modal - Actions
  'projects.cohortBuilderPage.derivedEventsEditModal.uniquenessFilterRestrictionTitle':
    'Only one uniqueness filter can be applied to a derived event.',
  'projects.cohortBuilderPage.derivedEventsEditModal.addUniquenessFilterButtonLabel':
    'Uniqueness Filter',
  'projects.cohortBuilderPage.derivedEventsEditModal.addTemporalConstraintButtonLabel':
    'Temporal constraint',
  'projects.cohortBuilderPage.derivedEventsEditModal.addCohortBuilderEventButtonLabel': 'Event',
  'projects.cohortBuilderPage.simpleEventEditCard.cancelButtonText': 'Close',

  // Cohort Builder - Derived Events Delete Modal
  'projects.cohortBuilderPage.derivedEventsDeleteModal.title': 'Delete derived event',
  'projects.cohortBuilderPage.derivedEventsDeleteModal.submittingTitle': 'Deleting derived event',
};
